import { gql } from 'graphql-request'

export const CREATE_POPUP_BANNER = gql`
  mutation CreatePopupBanner($createPopupBannerInput: CreatePopupBannerInput!) {
    createPopupBanner(createPopupBannerInput: $createPopupBannerInput) {
      id
    }
  }
`
